/** LLM providers generation can route to; the server, web picker and request contracts read this list. */

export const LLM_PROVIDERS = ['anthropic', 'gemini', 'deepseek', 'openai'] as const;

export type LlmProvider = (typeof LLM_PROVIDERS)[number];

/**
 * How a generation's provider was chosen. `comparison` marks a comparison run's card (backlog 115),
 * which no global reader may count; `failover` is reserved for backlog 211.
 */
export const PROVIDER_CHOICES = ['default', 'mix', 'admin', 'failover', 'comparison'] as const;

export type ProviderChoice = (typeof PROVIDER_CHOICES)[number];

/** Stored when no provider was chosen or it cannot be known, never a guessed one (backlog 218). */
export const UNKNOWN_PROVIDER = 'unknown';

export type RecordedProvider = LlmProvider | typeof UNKNOWN_PROVIDER;

/** Check if a value is a known LlmProvider */
export function isLlmProvider(value: unknown): value is LlmProvider {
  return typeof value === 'string' && (LLM_PROVIDERS as readonly string[]).includes(value);
}
